// Directory mode: the app works as a public dance directory (map, schools,
// timetables, events). The school-management features (dashboard, students,
// subscriptions, attendance, QR...) are hidden but kept in the codebase so
// they can be re-enabled for schools that join the platform later.
// Set VUE_APP_DIRECTORY_MODE=false to bring the management app back.
export const DIRECTORY_MODE = process.env.VUE_APP_DIRECTORY_MODE !== 'false';
